import React from 'react';
import { shouldDisplayVeryPayWidget } from 'client/utils/utils';
import { PageType, Brand } from '@tvg/product-listing-url';
import BannerContainer from './BannerContainer';
import { RecsGridItem, RecsGridItemProps } from './Recs';
import VeryPayWidgetContainer from './VeryPayWidgetContainer';

const MIN_PRODUCTS_FOR_PLACEMENTS = 30;
export const PLACEMENT_CONTAINERS = [
  { position: 2, placement: RecsGridItem },
  { position: 4, placement: RecsGridItem },
  {
    position: 6,
    // eslint-disable-next-line react/jsx-props-no-spreading
    placement: (props: RecsGridItemProps) => <RecsGridItem {...props} lastOfType />,
  },
  { position: 6, placement: BannerContainer },
  { position: 12, placement: VeryPayWidgetContainer, isVeryPayWidget: true },
  { position: 36, placement: BannerContainer },
  { position: 54, placement: BannerContainer },
  { position: 72, placement: BannerContainer },
].reverse();

export const withPlacementContainers = (
  items: React.JSX.Element[],
  options?: {
    veryPayExperiments?: Record<string, string>;
    pageType?: PageType;
    brand?: Brand;
    isUnknowCustomer?: boolean;
  },
) => {
  if (items.length < MIN_PRODUCTS_FOR_PLACEMENTS) return items;
  const updatedItems = [...items];

  PLACEMENT_CONTAINERS.forEach(({ position, placement: Placement, isVeryPayWidget = false }, idx) => {
    if (position > items.length) return;
    if (!isVeryPayWidget) {
      // eslint-disable-next-line react/no-array-index-key
      updatedItems.splice(position, 0, <Placement key={`placement-${idx}`} itemKey={position} />);
      return;
    }
    // Add VeryPay widget if conditions are met
    if (
      options?.veryPayExperiments &&
      options?.pageType &&
      options?.brand &&
      options?.isUnknowCustomer !== undefined &&
      shouldDisplayVeryPayWidget(options.veryPayExperiments, options.pageType, options.brand, options?.isUnknowCustomer)
    ) {
      // eslint-disable-next-line react/no-array-index-key
      updatedItems.splice(position, 0, <Placement key={`placement-${idx}`} itemKey={position} />);
    }
  });

  return updatedItems;
};
